(function() {
  'use strict';

  function LoadingCtrl($scope, $rootScope) {

    $scope.showLoading = null;

    var x = $rootScope.$on('loading:start', function(event) {
      event.preventDefault();
      $scope.showLoading = true;
    });

    var y = $rootScope.$on('loading:stop', function(event) {
      event.preventDefault();
      $scope.showLoading = false;
    });

    // $scope $destroy
    $scope.$on('$destroy', x);
    $scope.$on('$destroy', y);

  }

  angular
    .module('mandaeApp')
    .controller('LoadingCtrl', LoadingCtrl);

}());
